<div class="plan-popup bg-white rounded-lg border border-slate-200 overflow-hidden relative">
  <!-- Load plan error (GET /plans/{planId} failed) -->
  <div *ngIf="loadPlanError" class="px-4 py-3 bg-red-50 border-b border-red-200 flex items-center justify-between gap-4">
    <div class="flex items-center gap-2 text-red-800 text-sm">
      <i class="fas fa-exclamation-circle"></i>
      <span>{{ loadPlanError }}</span>
    </div>
    <button type="button" (click)="dismissLoadPlanError()" class="text-red-600 hover:text-red-800 text-sm font-medium shrink-0">
      Dismiss
    </button>
  </div>
  <!-- Loading plan details (GET /plans/{planId} in progress) -->
  <div *ngIf="isLoadingPlan" class="absolute inset-0 bg-white/80 z-10 flex items-center justify-center rounded-lg">
    <div class="flex flex-col items-center gap-2 text-primary">
      <i class="fas fa-spinner fa-spin text-2xl"></i>
      <span class="text-sm font-medium">Loading plan details...</span>
    </div>
  </div>
  <!-- Save error display -->
  <div *ngIf="saveError" class="px-4 py-3 bg-red-50 border-b border-red-200 flex items-center justify-between gap-4">
    <div class="flex items-center gap-2 text-red-800 text-sm">
      <i class="fas fa-exclamation-circle"></i>
      <span>{{ saveError }}</span>
    </div>
    <button type="button" (click)="dismissSaveError()" class="text-red-600 hover:text-red-800 text-sm font-medium shrink-0">
      Dismiss
    </button>
  </div>
  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="p-4 pt-3 pb-4">
    <!-- Two columns: Plan Details (left) | Configuration (right) -->
    <div class="grid grid-cols-1 lg:grid-cols-2 plan-popup-grid mb-5">
      <!-- Left: Plan Details – app-input matches Add Patient page (no pencil icon, no shine) -->
      <div class="flex flex-col gap-2">
        <div class="plan-popup-cell">
          <app-input formControlName="planName" label="Plan Name" [required]="true"></app-input>
        </div>
        <div class="plan-popup-cell">
          <app-input formControlName="description" label="Description"></app-input>
        </div>
        <div class="plan-popup-cell">
          <app-input formControlName="contact" label="Contact"></app-input>
        </div>
        <div class="plan-popup-cell">
          <app-dropdown formControlName="insurance" label="Insurance" [options]="insuranceOptions" [required]="true" placeholder="Select Insurance"></app-dropdown>
        </div>
        <div class="plan-popup-cell">
          <app-dropdown formControlName="category" label="Category" [options]="categoryOptions" [required]="true" placeholder="Select Category"></app-dropdown>
        </div>
        <div class="plan-popup-cell">
          <app-input formControlName="comments" label="Comments" type="textarea" [rows]="2"></app-input>
        </div>
        <div class="plan-popup-cell">
          <app-input formControlName="outstandingDays" label="Outstanding Days" type="number"></app-input>
        </div>
        <div class="plan-popup-cell">
          <app-dropdown formControlName="anesthesiaLink" label="Anesthesia Link" [options]="anesthesiaLinkOptions"
            placeholder="None Selected"></app-dropdown>
        </div>
        <div class="plan-popup-cell">
          <app-dropdown formControlName="submitVendor" label="Submit Vendor" [options]="submitVendorOptions" placeholder="Select Submit Vendor"></app-dropdown>
        </div>
      </div>

      <!-- Right: Configuration -->
      <div class="flex flex-col gap-2">
        <div class="plan-popup-cell">
          <div class="flex items-center gap-3">
            <span class="text-[13px] font-semibold text-slate-800">Active :</span>
            <div class="flex gap-4">
              <label class="inline-flex items-center gap-2 cursor-pointer">
                <input type="radio" formControlName="active" [value]="true" class="text-primary" />
                <span class="text-[14px] text-slate-800">Yes</span>
              </label>
              <label class="inline-flex items-center gap-2 cursor-pointer">
                <input type="radio" formControlName="active" [value]="false" class="text-primary" />
                <span class="text-[14px] text-slate-800">No</span>
              </label>
            </div>
          </div>
        </div>
        <div class="plan-popup-cell">
          <div class="flex items-center gap-3">
            <span class="text-[13px] font-semibold text-slate-800">Managed Care :</span>
            <div class="flex gap-4">
              <label class="inline-flex items-center gap-2 cursor-pointer">
                <input type="radio" formControlName="managedCare" [value]="true" class="text-primary" />
                <span class="text-[14px] text-slate-800">Yes</span>
              </label>
              <label class="inline-flex items-center gap-2 cursor-pointer">
                <input type="radio" formControlName="managedCare" [value]="false" class="text-primary" />
                <span class="text-[14px] text-slate-800">No</span>
              </label>
            </div>
          </div>
        </div>
        <div class="plan-popup-cell">
          <div class="flex items-center gap-3">
            <span class="text-[13px] font-semibold text-slate-800">Capitated :</span>
            <div class="flex gap-4">
              <label class="inline-flex items-center gap-2 cursor-pointer">
                <input type="radio" formControlName="capitated" [value]="true" class="text-primary" />
                <span class="text-[14px] text-slate-800">Yes</span>
              </label>
              <label class="inline-flex items-center gap-2 cursor-pointer">
                <input type="radio" formControlName="capitated" [value]="false" class="text-primary" />
                <span class="text-[14px] text-slate-800">No</span>
              </label>
            </div>
          </div>
        </div>
        <div class="plan-popup-cell">
          <div class="flex items-center gap-3">
            <span class="text-[13px] font-semibold text-slate-800">Cap Auto Writeoff :</span>
            <div class="flex gap-4">
              <label class="inline-flex items-center gap-2 cursor-pointer">
                <input type="radio" formControlName="capAutoWriteoff" [value]="true" class="text-primary" />
                <span class="text-[14px] text-slate-800">Yes</span>
              </label>
              <label class="inline-flex items-center gap-2 cursor-pointer">
                <input type="radio" formControlName="capAutoWriteoff" [value]="false" class="text-primary" />
                <span class="text-[14px] text-slate-800">No</span>
              </label>
            </div>
          </div>
        </div>
        <div class="plan-popup-cell">
          <div class="flex items-center gap-3">
            <span class="text-[13px] font-semibold text-slate-800">Elect Submit :</span>
            <div class="flex gap-4">
              <label class="inline-flex items-center gap-2 cursor-pointer">
                <input type="radio" formControlName="electSubmit" [value]="true" class="text-primary" />
                <span class="text-[14px] text-slate-800">Yes</span>
              </label>
              <label class="inline-flex items-center gap-2 cursor-pointer">
                <input type="radio" formControlName="electSubmit" [value]="false" class="text-primary" />
                <span class="text-[14px] text-slate-800">No</span>
              </label>
            </div>
          </div>
        </div>
        <div class="plan-popup-cell">
          <div class="flex items-center gap-3">
            <span class="text-[13px] font-semibold text-slate-800">Elec EOB Writeoff :</span>
            <div class="flex gap-4">
              <label class="inline-flex items-center gap-2 cursor-pointer">
                <input type="radio" formControlName="elecEobWriteoff" [value]="true" class="text-primary" />
                <span class="text-[14px] text-slate-800">Yes</span>
              </label>
              <label class="inline-flex items-center gap-2 cursor-pointer">
                <input type="radio" formControlName="elecEobWriteoff" [value]="false" class="text-primary" />
                <span class="text-[14px] text-slate-800">No</span>
              </label>
            </div>
          </div>
        </div>
        <div class="plan-popup-cell">
          <div class="flex items-center gap-3">
            <span class="text-[13px] font-semibold text-slate-800">PIN Relation :</span>
            <div class="flex gap-4">
              <label class="inline-flex items-center gap-2 cursor-pointer">
                <input type="radio" formControlName="pinRelation" [value]="true" class="text-primary" />
                <span class="text-[14px] text-slate-800">Yes</span>
              </label>
              <label class="inline-flex items-center gap-2 cursor-pointer">
                <input type="radio" formControlName="pinRelation" [value]="false" class="text-primary" />
                <span class="text-[14px] text-slate-800">No</span>
              </label>
            </div>
          </div>
        </div>
        <div class="plan-popup-cell">
          <app-dropdown formControlName="form" label="Form" [options]="formOptions" placeholder="Select"></app-dropdown>
        </div>
        <div class="plan-popup-cell">
          <label class="block text-[13px] font-medium text-slate-700 mb-2">Plan Type</label>
          <div class="flex gap-4 flex-wrap">
            <label class="inline-flex items-center gap-2 cursor-pointer">
              <input type="radio" formControlName="planType" value="medical" class="text-primary" />
              <span class="text-[14px] text-slate-800">Medical</span>
            </label>
            <label class="inline-flex items-center gap-2 cursor-pointer">
              <input type="radio" formControlName="planType" value="no-fault" class="text-primary" />
              <span class="text-[14px] text-slate-800">No Fault</span>
            </label>
            <label class="inline-flex items-center gap-2 cursor-pointer">
              <input type="radio" formControlName="planType" value="wc" class="text-primary" />
              <span class="text-[14px] text-slate-800">WC</span>
            </label>
          </div>
        </div>
        <div class="plan-popup-cell">
          <app-input formControlName="statementComments" label="Statement Comments" type="textarea" [rows]="2"></app-input>
        </div>
      </div>
    </div>

    <!-- Address: field sequence matches legacy UI (Address | City | State/Zip/Ext on first row; Contact | Tel/Ext | Fax on second row) -->
    <div class="border-t border-slate-200 pt-3 mb-4">
      <h3 class="text-sm font-semibold text-slate-700 mb-2">Address</h3>
      <div class="grid grid-cols-1 md:grid-cols-3 gap-x-3 gap-y-2">
        <!-- Row 1 -->
        <div>
          <app-input formControlName="address" label="Address"></app-input>
        </div>
        <div>
          <app-input formControlName="city" label="City"></app-input>
        </div>
        <div class="flex gap-2 items-end flex-nowrap">
          <div class="w-20">
            <app-input formControlName="state" label="State" placeholder="XX"></app-input>
          </div>
          <div class="w-28">
            <app-input formControlName="zip" label="Zip" placeholder="00000"></app-input>
          </div>
          <div class="w-20">
            <app-input formControlName="zipExt" label="Ext"></app-input>
          </div>
        </div>
        <!-- Row 2 -->
        <div>
          <app-input formControlName="addressContact" label="Contact"></app-input>
        </div>
        <div class="flex gap-2 items-end">
          <div class="flex-1 min-w-0">
            <app-input formControlName="tel" label="Tel" type="tel" placeholder="(XXX) XXX-XXXX"></app-input>
          </div>
          <div class="w-24">
            <app-input formControlName="telExt" label="Ext"></app-input>
          </div>
        </div>
        <div>
          <app-input formControlName="fax" label="Fax"></app-input>
        </div>
      </div>
    </div>

    <!-- Claim Flag -->
    <div class="border-t border-slate-200 pt-4 mb-6">
      <h3 class="text-sm font-semibold text-slate-700 mb-3">Claim Flag</h3>
      <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2">
        <label class="inline-flex items-center gap-2 cursor-pointer">
          <input type="checkbox" formControlName="claimFlagMedicare" class="rounded border-slate-300 text-primary" />
          <span class="text-[14px] text-slate-800">Medicare</span>
        </label>
        <label class="inline-flex items-center gap-2 cursor-pointer">
          <input type="checkbox" formControlName="claimFlagMedicaid" class="rounded border-slate-300 text-primary" />
          <span class="text-[14px] text-slate-800">Medicaid</span>
        </label>
        <label class="inline-flex items-center gap-2 cursor-pointer">
          <input type="checkbox" formControlName="claimFlagChampus" class="rounded border-slate-300 text-primary" />
          <span class="text-[14px] text-slate-800">Champus</span>
        </label>
        <label class="inline-flex items-center gap-2 cursor-pointer">
          <input type="checkbox" formControlName="claimFlagChampva" class="rounded border-slate-300 text-primary" />
          <span class="text-[14px] text-slate-800">Champva</span>
        </label>
        <label class="inline-flex items-center gap-2 cursor-pointer">
          <input type="checkbox" formControlName="claimFlagGroup" class="rounded border-slate-300 text-primary" />
          <span class="text-[14px] text-slate-800">Group</span>
        </label>
        <label class="inline-flex items-center gap-2 cursor-pointer">
          <input type="checkbox" formControlName="claimFlagOthers" class="rounded border-slate-300 text-primary" />
          <span class="text-[14px] text-slate-800">Others</span>
        </label>
        <label class="inline-flex items-center gap-2 cursor-pointer">
          <input type="checkbox" formControlName="claimFlagFECA" class="rounded border-slate-300 text-primary" />
          <span class="text-[14px] text-slate-800">FECA</span>
        </label>
        <label class="inline-flex items-center gap-2 cursor-pointer">
          <input type="checkbox" formControlName="claimFlagBCBS" class="rounded border-slate-300 text-primary" />
          <span class="text-[14px] text-slate-800">BC/BS</span>
        </label>
        <label class="inline-flex items-center gap-2 cursor-pointer">
          <input type="checkbox" formControlName="claimFlagGHIMedicare" class="rounded border-slate-300 text-primary" />
          <span class="text-[14px] text-slate-800">GHI Medicare</span>
        </label>
        <label class="inline-flex items-center gap-2 cursor-pointer">
          <input type="checkbox" formControlName="claimFlagFidelis" class="rounded border-slate-300 text-primary" />
          <span class="text-[14px] text-slate-800">Fidelis</span>
        </label>
        <label class="inline-flex items-center gap-2 cursor-pointer">
          <input type="checkbox" formControlName="claimFlagHealthFirst" class="rounded border-slate-300 text-primary" />
          <span class="text-[14px] text-slate-800">HealthFirst</span>
        </label>
      </div>
    </div>

    <!-- Claim Option -->
    <div class="border-t border-slate-200 pt-4 mb-6">
      <h3 class="text-sm font-semibold text-slate-700 mb-3">Claim Option</h3>
      <div class="flex flex-wrap gap-4">
        <label class="inline-flex items-center gap-2 cursor-pointer">
          <input type="checkbox" formControlName="claimOptReserved" class="rounded border-slate-300 text-primary" />
          <span class="text-[14px] text-slate-800">Reserved Field 24 K</span>
        </label>
        <label class="inline-flex items-center gap-2 cursor-pointer">
          <input type="checkbox" formControlName="claimOptSecondaryBill" class="rounded border-slate-300 text-primary" />
          <span class="text-[14px] text-slate-800">Secondary Bill Allowed</span>
        </label>
        <label class="inline-flex items-center gap-2 cursor-pointer">
          <input type="checkbox" formControlName="claimOptAnesthesiaBill" class="rounded border-slate-300 text-primary" />
          <span class="text-[14px] text-slate-800">Anesthesia Bill Minutes</span>
        </label>
      </div>
    </div>

  </form>

  <!-- Save success popup (same style as Edit Patient): professional layout with icons -->
  <div *ngIf="showSaveSuccessPopup" class="save-success-popup-backdrop fixed inset-0 bg-slate-900/50 backdrop-blur-[2px] z-[9999] flex items-center justify-center p-4"
      (click)="$event.stopPropagation()">
      <div class="save-success-popup bg-white rounded-xl shadow-2xl w-full max-w-md overflow-hidden"
          (click)="$event.stopPropagation()">
          <!-- Header -->
          <div class="flex items-center gap-3 px-5 py-4 bg-[var(--primary)]">
              <div class="flex-shrink-0 w-11 h-11 rounded-full bg-white/20 flex items-center justify-center">
                  <i class="fas fa-check-circle text-white text-xl"></i>
              </div>
              <h3 class="text-white text-lg font-semibold tracking-tight">Information</h3>
          </div>
          <!-- Body: icon + message -->
          <div class="px-6 py-8 flex flex-col items-center text-center">
              <div class="w-16 h-16 rounded-full bg-emerald-100 flex items-center justify-center mb-4">
                  <i class="fas fa-check text-emerald-600 text-3xl"></i>
              </div>
              <p class="text-slate-800 text-base font-semibold leading-relaxed">Record Saved Successfully</p>
          </div>
          <!-- Footer -->
          <div class="px-6 py-4 bg-slate-50 border-t border-slate-100 flex justify-center">
              <button type="button"
                  class="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg text-sm font-semibold bg-[var(--primary)] text-white hover:opacity-95 focus:outline-none focus:ring-2 focus:ring-[var(--primary)] focus:ring-offset-2 transition-opacity"
                  (click)="showSaveSuccessPopup = false; close.emit()">
                  <i class="fas fa-check text-white text-sm"></i>
                  Ok
              </button>
          </div>
      </div>
  </div>
</div>
